module.exports = __webpack_public_path__ + "static/media/H.G. Mar Mathew.4ca328a7.png";